import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BigBannerBlockWrapper',
  setup(__props) {

const isPlaying = ref<boolean>(false);

const onPlay = () => {
  isPlaying.value = true;
};

const onPause = () => {
  isPlaying.value = false;
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    isPlaying: isPlaying.value,
    onPlay: onPlay,
    onPause: onPause
  })
}
}

})